/* TBM Liquid Glass v2: establish the actual sticky header host,
   track scroll state; no menu, cart or search behaviour is changed. */
(function () {
  'use strict';
  function setup() {
    var header = document.querySelector('header.site-header');
    if (!header) return;
    var host = header.closest('.shopify-section');
    if (!host) return;
    host.classList.add('tbm-liquidglass-host');
    var last = null;
    function update() {
      var next = (window.scrollY || window.pageYOffset || 0) > 16;
      if (next !== last) {
        host.classList.toggle('tbm-liquidglass-scrolled', next);
        last = next;
      }
    }
    update();
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('pageshow', update);
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.contains(header)) {
        host.classList.add('tbm-liquidglass-host');
        update();
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, {once:true});
  } else { setup(); }
}());
